import { createService } from '@bonanza-social/toolkit/api';
import { VerifyAddressSchema } from './AccountService.schemas';

export default createService(
  {
    verifyAddress: {
      method: 'PUT',
      url: '/kyc/reinitialization',
      responseSchema: VerifyAddressSchema,
    },
  },
  ({ userId }) => `/Accounts/${userId}`,
);
